export enum CacheHeaders {
	TTL = 'X-CacheTimeToLiveInSeconds',
	Invalidate = 'X-CacheInvalidate',
	CacheType = 'X-CacheType'
}

export enum CacheTypes {
	InMemory = 'InMemory',
	LocalStorage = 'LocalStorage'
}